/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Headline = 'Website.Basket.Samples.SingleSample.Headline';
export const Subtitle = 'Website.Basket.Samples.SingleSample.Subtitle';
export const Description = 'Website.Basket.Samples.SingleSample.Description';
export const AddSample = 'Website.Basket.Samples.SingleSample.AddSample';
export const SelectedSampleName = 'Website.Basket.Samples.SingleSample.SelectedSampleName';
export const SelectedSampleDescription = 'Website.Basket.Samples.SingleSample.SelectedSampleDescription';
